import styled from 'styled-components';

import { PregnancyCompletion } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { dateFormatter, Translate } from '@dreryk/react-common';

import { gynecologicalInterviewTranslationKeys } from '../../../translations';

type GynecologicalInterviewPregnancyCompletionEntryCellProps = {
   readonly pregnancyCompletionInterview: PregnancyCompletion;
};

const StyledGynecologicalInterviewPregnancyCompletionEntryCell = styled.span`
   text-transform: lowercase;
   &:first-letter {
      text-transform: uppercase;
   }
`;
StyledGynecologicalInterviewPregnancyCompletionEntryCell.displayName =
   'StyledGynecologicalInterviewPregnancyCompletionEntryCell';

export const GynecologicalInterviewPregnancyCompletionEntryCell = (
   props: GynecologicalInterviewPregnancyCompletionEntryCellProps
): JSX.Element => {
   return (
      <StyledGynecologicalInterviewPregnancyCompletionEntryCell>
         <Translate>
            {
               gynecologicalInterviewTranslationKeys.interviewType[
                  props.pregnancyCompletionInterview.pregnancyCompletionType
               ]
            }
         </Translate>
         {props.pregnancyCompletionInterview.completionDate ? (
            <>
               {', '}
               <Translate>{gynecologicalInterviewTranslationKeys.pregnancyCompletionDate}</Translate>
               {': '}
               {dateFormatter(props.pregnancyCompletionInterview.completionDate)}
            </>
         ) : null}
      </StyledGynecologicalInterviewPregnancyCompletionEntryCell>
   );
};
